import React from "react";
import { motion } from "framer-motion";
import { MapPin, Trophy } from "lucide-react";
import "../css/About.css";

const About: React.FC = () => {
    return (
        <motion.section
            className="about"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1 }}
            viewport={{ once: false, amount: 0.2 }}
        >

            <div className="about-container">
                {/* Left Side - Image with Location Tag */}
                <motion.div
                    className="about-image-container"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.2 }}
                    viewport={{ once: false, amount: 0.2 }}
                >
                    {/* Pattern Background */}
                    <div className="pattern-bg"></div>

                    {/* Image */}
                    <img src="assets/images/about.jpg" alt="Historical Carving" />

                    {/* Location */}
                    <motion.a
                        href="https://maps.app.goo.gl/jbVtSsE7BiiuDJddA"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="about-location"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.4 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <MapPin size={50} color="#68F8FD" />
                        <p>#42, Samdach Pan Street (214), Sangkat Boeung Raing, Khan Daun Penh, Phnom Penh.</p>
                    </motion.a>
                </motion.div>

                {/* Right Side - Text Content */}
                <motion.div
                    className="about-content"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.2 }}
                >
                    <h3 className="about-title">About</h3>
                    <h2 className="about-heading">Sok Im Holding</h2>
                    <p className="about-description">
                        Sayon, the flagship brand of Sok Im Holding, is a leading conglomerate with over three decades of excellence in Cambodia. With a diverse portfolio spanning Trading, FMCG, Property, Internet Services, and Data Centers, Sayon has established itself as a trusted partner for both national and international businesses. Renowned for our ethical practices, unwavering integrity, and strong relationships with key stakeholders, Sayon continues to drive growth and innovation across multiple industries, making us the partner of choice in the region.
                    </p>

                    {/* Years of Excellence */}
                    <motion.div
                        className="about-excellence"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.7 }}
                        viewport={{ once: false, amount: 0.2 }}
                    >
                        <div className="icon">
                            <Trophy size={24} color="#029297" />
                        </div>
                        <div>
                            <p className="titl-excellence">Years of Excellence</p>
                            <p className="about-description">Established in 2007, Sok Im Holding has been at the forefront of driving innovation and growth across multiple industries in Cambodia.</p>
                        </div>
                    </motion.div>
                </motion.div>
            </div>
        </motion.section>
    );
};

export default About;